import React, { Component, Fragment } from "react";
import { getUUIDBaseDataAPI, sendOTPAPI, verifyOTPAPI } from "../../APIs";
import { GET_DOCUMENT_DEC_URL, INVALID_MESSAGE, LOADER_RED, API_STATIC_TOKEN, BACKEND_BASE_URL } from "../../constant";
import myhealthcareLogo from '../../assets/image/logo.png';
import RFHLogo from '../../assets/image/rfh-logo.png';
import axios from "axios";
// import PDFViewer from "./PDFViewer";
import PDFViewerV2 from "./PDFViewerV2";

export default class ViewDocumentAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      rxFilePath: null,
      fileContentType: 'application/pdf',
      uuid: null,
      OTPRequire: false,
      OTPSendSubmit: false,
      OTPMessage: { type: '', text: '' },
      notFoundMessage: { type: '', text: '' },
      OTP: null,
      OTPTitle: "",
      submitBtnDisable: false,
      to_many_attempt: false,
      maskedMobile: null,
      ENTER_INVALID_MSG: "You have entered invalid OTP consecutively 5 times, please try again after 5 minutes.",
      LIMIT_REACHED_MSG: "OTP limit has been reached, please try again after 5 minutes.",
      OTP_TITLE: "Please enter the OTP sent on {maskedMobile} in below field:",
      MASKED_MESSAGE: 'For authentication purposes an OTP will be sent to this mobile number {maskedMobile}./n/nClick below button to send OTP',
    };

    this.timeout = null;
    this.isEffectRun = false;
  }

  componentDidMount() {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');
    const uuid = parts.length ? parts.slice(-1)[0] : null;
    if (uuid && !this.isEffectRun) {
      this.getUUIDBaseData(uuid);
      this.isEffectRun = true; // Mark as executed
      this.setState({ uuid });
    }
  }

  getUUIDBaseData = async (uuid) => {
    try {
      let apiRes = await getUUIDBaseDataAPI({ uuid });
      if (apiRes.status === 200 && apiRes.data.statusCode === 200 && Object.keys(apiRes?.data?.data).length) {
        if (apiRes?.data?.data?.expiry) {
          this.setState({ showLoader: false, notFoundMessage: { type: 'error', text: apiRes?.data?.message } });
          return;
        }
        if (apiRes.data.data?.is_login_required) {
          let maskedMobile = apiRes.data.data.mobile || null;
          let maskedMsg = this.state.MASKED_MESSAGE.replaceAll("{maskedMobile}", maskedMobile);
          let OTPTitle = this.state.OTP_TITLE.replaceAll("{maskedMobile}", maskedMobile);
          this.setState({ OTPRequire: true, OTPTitle, maskedMobile, OTPMessage: { type: 'success', text: maskedMsg } });
        } else {
          let encFilepath = apiRes?.data?.data?.filepath;
          if (encFilepath) {
            this.setState({ showLoader: true });
            this.getDocumentBuffer(decodeURIComponent(encFilepath));
          }
          else if (apiRes?.data?.data?.url) {
            window.location.href = apiRes?.data?.data?.url;
          }
        }
      }
      else {
        this.setState({ showLoader: false, notFoundMessage: { type: 'error', text: apiRes?.data?.message } });
      }
    }
    catch (err) {
      console.log('get-uuid-base-data-err:', err);
      this.setState({ showLoader: false, notFoundMessage: { type: 'error', text: INVALID_MESSAGE } });
    }
  };

  getDocumentBuffer = async (encFilepath) => {
    try {
      const payloadObj = { filepath: encFilepath, uuid: this.state.uuid };
      const headers = { "Authorization": API_STATIC_TOKEN };
      let bufferApiRes = await axios.post(GET_DOCUMENT_DEC_URL, payloadObj, { responseType: "arraybuffer", headers });

      if (bufferApiRes.status === 200 && bufferApiRes?.data) {
        const contentType = bufferApiRes.headers['content-type'];
        // console.log('-----get-content-type:', contentType);
        const blob = new Blob([bufferApiRes.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        this.setState({ showLoader: false, OTPRequire: false, rxFilePath: url, fileContentType: contentType });
      } else {
        this.setState({ showLoader: false, OTPMessage: { type: 'error', text: INVALID_MESSAGE } });
      }
    } catch (err) {
      this.setState({ showLoader: false, OTPMessage: { type: 'error', text: INVALID_MESSAGE } });
      console.log('get-document-buffer-err:', err);
    }
  };

  handleVerifyOTPSubmit = async () => {
    try {
      var msgDuration = null;
      const { OTP, uuid, ENTER_INVALID_MSG } = this.state;
      if (OTP) {
        this.setState({ submitBtnDisable: true });
        let verifyOTPAPIRes = await verifyOTPAPI({ uuid: uuid, otp: OTP });
        if (verifyOTPAPIRes.status === 200 && verifyOTPAPIRes.data.statusCode === 200) {
          if (verifyOTPAPIRes.data?.filepath) {
            this.setState({ showLoader: true });
            this.getDocumentBuffer(decodeURIComponent(verifyOTPAPIRes.data.filepath));
          } else {
            if (verifyOTPAPIRes?.data?.to_many_attempt) {
              msgDuration = 300000;
              this.setState({
                to_many_attempt: true,
                OTPRequire: true,
                OTPSendSubmit: false,
                OTP: '',
                submitBtnDisable: false,
                OTPMessage: { type: 'error', text: ENTER_INVALID_MSG }
              });
            }
            else {
              this.setState({
                OTP: '',
                submitBtnDisable: false,
                OTPMessage: { type: 'error', text: verifyOTPAPIRes?.data?.message }
              });
            }
          }
        } else {
          this.setState({ OTP: '', submitBtnDisable: false, OTPMessage: { type: 'error', text: verifyOTPAPIRes?.data?.message } });
        }
      } else {
        this.setState({ OTP: '', submitBtnDisable: false, OTPMessage: { type: 'error', text: "OTP is required!" } });
      }
      this.messageDisappear(msgDuration);
    } catch (err) {
      console.log('handle-verify-OTP-submit-err:', err);
    }
  };

  handleResendOTP = async () => {
    var msgDuration = null;
    const { uuid, LIMIT_REACHED_MSG, ENTER_INVALID_MSG } = this.state;
    try {
      this.setState({ submitBtnDisable: true });
      let reSendOTPAPIRes = await sendOTPAPI({ uuid });
      if (reSendOTPAPIRes.status === 200 && reSendOTPAPIRes.data.statusCode === 200) {
        let message = reSendOTPAPIRes.data.message;
        let errType = message.includes('attempts') ? 'error' : 'info';
        if (reSendOTPAPIRes?.data?.to_many_attempt) {
          msgDuration = 300000;
          let warningMsg = reSendOTPAPIRes?.data?.warning ? ENTER_INVALID_MSG : LIMIT_REACHED_MSG;
          this.setState({
            to_many_attempt: true,
            OTPRequire: true,
            OTPSendSubmit: false,
            OTPMessage: { type: errType, text: warningMsg }
          });
        }
        else {
          this.setState({ OTP: '', OTPMessage: { type: errType, text: message || '' }, OTPSendSubmit: true });
        }
      } else {
        this.setState({ OTP: '', OTPMessage: { type: 'info', text: reSendOTPAPIRes.data.message || '' } });
      }
      this.messageDisappear(msgDuration);
    } catch (err) {
      console.log('handle-resend-OTP-submit-err:', err);
    }
    this.setState({ submitBtnDisable: false });
  };

  handleChange = (e) => {
    this.setState({ OTP: e.target.value });
  };

  handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  messageDisappear = (duration) => {
    duration = duration || 3000;
    let msg = duration == 300000 ? this.state.MASKED_MESSAGE.replaceAll("{maskedMobile}", this.state.maskedMobile) : null;
    clearTimeout(this.timeout); // Clear any existing timeout
    this.timeout = setTimeout(() => {
      this.setState({ OTPMessage: { type: '', text: msg } });
    }, duration);
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const { showLoader, rxFilePath, fileContentType, OTPRequire, OTPSendSubmit, OTPMessage, OTP, submitBtnDisable, notFoundMessage, OTPTitle } = this.state;
    const formattedText = OTPMessage.text ? OTPMessage.text.replaceAll('/n', '<br />') : null;
    /* ------------------------------ logo base on env wise ------------------------------ */
    let logoFile = myhealthcareLogo;
    if (BACKEND_BASE_URL.includes('rfh')) {
      logoFile = RFHLogo
    }
    /* ------------------------------ logo base on env wise ------------------------------ */

    return (
      <Fragment>
        {showLoader ? <div className="d-flex justify-content-center align-items-center">
          <p className="mx-auto d-block mt-4 mb-2">{LOADER_RED}</p>
        </div> : null}

        {rxFilePath ? (
          <div className="full-screen-frame">
            {fileContentType.includes('pdf') ? (
              <PDFViewerV2 pdfUrl={rxFilePath} disabledDownloadBtn={OTPSendSubmit} />
              // <PDFViewer pdfUrl={rxFilePath} />
              // <iframe src={OTPSendSubmit ? rxFilePath + "#toolbar=0" : rxFilePath} frameBorder="0" scrolling="no" className="iframe-style" alt="PDF Document"> {LOADER_RED} </iframe>
            ) : (
              <img src={rxFilePath} alt="Image Document" className="iframe-style" />
            )}
          </div>
        ) : null}

        {notFoundMessage.text ?
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div role="alert" className={`alert ${notFoundMessage.type === 'error' ? 'alert-danger' : notFoundMessage.type === 'success' ? 'alert-success' : 'alert-info'}`}> {notFoundMessage.text}
            </div>
          </div>
          : null}

        {OTPRequire && (
          <div className="d-flex justify-content-center align-items-center vh-100">
            <form className="p-4 border rounded" style={{ width: '400px' }}>
              <img className="mx-auto d-block mb-4" src={logoFile} style={{ height: "142px", width: "auto" }} alt="Logo"></img>
              <h3 className="d-flex justify-content-center align-items-center mb-4">View Document</h3>
              {OTPMessage.text && (
                <div role="alert" className={`alert ${OTPMessage.type === 'error' ? 'alert-danger' : OTPMessage.type === 'success' ? 'alert-success' : 'alert-info'}`}
                  dangerouslySetInnerHTML={{ __html: formattedText }}
                >
                  {/* {OTPMessage.text} */}
                </div>
              )}
              {OTPSendSubmit && (
                <div className="mb-3">
                  {OTPTitle ? <label htmlFor="otp" className="form-label">{OTPTitle}</label> : null}
                  <input
                    type="tel"
                    className="form-control"
                    onChange={(e) => this.handleChange(e)}
                    onKeyPress={(e) => this.handleKeyPress(e)}
                    placeholder="Enter OTP"
                    maxLength={6}
                    autoComplete="off"
                    value={OTP}
                    id="otpField"
                    autoFocus
                  />
                </div>
              )}

              {OTPSendSubmit ?
                <Fragment>
                  <div className="d-flex justify-content-between mt-4">
                    <button type="button" className="btn btn-secondary" disabled={submitBtnDisable} onClick={this.handleResendOTP}>Resend</button>
                    <button type="button" className="btn btn-primary" disabled={submitBtnDisable} onClick={this.handleVerifyOTPSubmit}>Verify</button>
                  </div>
                </Fragment>
                : <button type="button" className="btn btn-primary w-100" disabled={submitBtnDisable} onClick={this.handleResendOTP}>Send OTP</button>
              }

              {submitBtnDisable ?
                <div className="d-flex justify-content-center align-items-center">
                  <p className="mx-auto d-block mt-4 mb-2">{LOADER_RED}</p>
                </div>
                : null}
            </form>
          </div>
        )}
      </Fragment>
    );
  }
}